(() => {
  const root = document.querySelector('[data-product-root]');
  const data = document.querySelector('#ProductVariants');
  if (!root || !data) return;
  const variants = JSON.parse(data.textContent);
  const form = root.querySelector('form');
  const fields = [...root.querySelectorAll('[data-option-position]')];
  const idInput = root.querySelector('[data-variant-id]');
  const button = root.querySelector('[data-add]');
  const status = root.querySelector('[data-availability]');
  const timing = root.querySelector('[data-made-timing]');
  const price = root.querySelector('[data-price]');
  const fulfillment = root.querySelector('[data-fulfillment]');
  const timingInput = root.querySelector('[data-timing]');
  const sizeField = fields.find(field => field.dataset.optionName === 'size');
  const selection = {};
  const initiallySelected = variants.find(variant => String(variant.id) === root.dataset.selectedVariant);
  const labels = root.dataset;
  const render = () => {
    const values = fields.map(field => selection[field.dataset.optionPosition]);
    for (const field of fields) {
      for (const option of field.querySelectorAll('[data-option-value]')) {
        const position = Number(field.dataset.optionPosition);
        const proposal = [...values]; proposal[position - 1] = option.dataset.optionValue;
        const matches = variants.filter(variant => proposal.every((value, i) => !value || variant[`option${i+1}`] === value));
        const canOrder = matches.some(variant => variant.available);
        const madeOnly = matches.length > 0 && matches.every(variant => variant.inventory_management && variant.inventory_quantity <= 0 && variant.inventory_policy === 'continue');
        option.classList.toggle('sold-out', madeOnly);
        option.classList.toggle('unavailable', !canOrder);
        option.setAttribute('aria-pressed', String(selection[position] === option.dataset.optionValue));
      }
    }
    const variant = variants.find(item => values.every((value, i) => item[`option${i+1}`] === value));
    const size = sizeField && selection[sizeField.dataset.optionPosition];
    const needsSize = sizeField && !size;
    const made = !!(variant && variant.available && variant.inventory_management && variant.inventory_quantity <= 0 && variant.inventory_policy === 'continue');
    idInput.value = variant ? variant.id : '';
    button.disabled = !variant || !variant.available || needsSize;
    timing.hidden = !made;
    fulfillment.disabled = !made; timingInput.disabled = !made;
    fulfillment.value = made ? labels.mto : ''; timingInput.value = made ? timing.textContent.trim() : '';
    button.textContent = needsSize ? labels.chooseSize : made ? labels.madeButton.replace('{{ size }}', size || '') : variant && variant.available ? labels.add : labels.unavailable;
    status.textContent = needsSize ? labels.chooseSize : made ? labels.mto : variant && variant.available ? labels.ready : labels.unavailable;
    if (variant) price.innerHTML = (variant.compare_cents > variant.price_cents ? `<del>${variant.compare}</del>` : '') + `<strong>${variant.price}</strong>`;
  };
  for (const field of fields) {
    if (field !== sizeField) {
      const first = field.querySelector('[data-option-value]');
      if (first) selection[field.dataset.optionPosition] = (initiallySelected && initiallySelected[`option${field.dataset.optionPosition}`]) || first.dataset.optionValue;
    }
    field.querySelectorAll('[data-option-value]').forEach(option => {
      const selectOption = () => {
        selection[field.dataset.optionPosition] = option.dataset.optionValue;
        render();
      };
      option.addEventListener('pointerdown', selectOption);
      option.addEventListener('click', selectOption);
    });
  }
  root.querySelectorAll('.gallery-thumb').forEach(thumb => thumb.addEventListener('click', () => {
    const image = root.querySelector('#ProductMainImage');
    image.src = thumb.dataset.imageUrl; image.alt = thumb.dataset.imageAlt;
    root.querySelectorAll('.gallery-thumb').forEach(other => other.setAttribute('aria-pressed', String(other === thumb)));
  }));
  form?.addEventListener('submit', event => { if (button.disabled || !idInput.value) event.preventDefault(); });
  render();
})();
